import { all, takeLatest } from 'redux-saga/effects';

import { getUserDistance } from './user/sagas';

export default function* rootSaga() {
  return yield all([
    takeLatest('@user/GET_ADDRESS_DISTANCE', getUserDistance),
  ]);
}
